import React, { useState, useEffect, useCallback } from "react";
import contactService from "../../services/contactService";
import * as XLSX from "xlsx";

// Icons matching Contact.jsx design
const MagnifyingGlassIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
    />
  </svg>
);

const FunnelIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
    />
  </svg>
);

const PlusIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
  </svg>
);

const PencilIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
    />
  </svg>
);

const TrashIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
    />
  </svg>
);

const XMarkIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
  </svg>
);

const ChevronLeftIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
  </svg>
);

const ChevronRightIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
  </svg>
);

const DocumentArrowUpIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"
    />
  </svg>
);

const CheckIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
  </svg>
);

export default function ContactTab() {
  const [contacts, setContacts] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterGroup, setFilterGroup] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [contactsPerPage, setContactsPerPage] = useState(10);

  // Modals
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);

  // Forms
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    group: "",
    otherMessage: "",
    address: "",
  });

  const [uploadFile, setUploadFile] = useState(null);
  const [selectedGroupForUpload, setSelectedGroupForUpload] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadingProgress, setUploadingProgress] = useState("");

  const loadContacts = useCallback(async () => {
    setLoading(true);
    try {
      const res = await contactService.get({ limit: 1000 });
      if (res && res.success) {
        setContacts(Array.isArray(res.data) ? res.data : []);
      } else if (Array.isArray(res)) {
        setContacts(res);
      }
    } catch (error) {
      console.error("Error loading contacts:", error);
      setContacts([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const loadGroups = useCallback(async () => {
    try {
      const res = await contactService.groups.get({ limit: 500 });
      if (res && res.success) {
        setGroups(Array.isArray(res.data) ? res.data : []);
      } else if (Array.isArray(res)) {
        setGroups(res);
      }
    } catch (error) {
      console.error("Error loading groups:", error);
      setGroups([]);
    }
  }, []);

  useEffect(() => {
    loadContacts();
    loadGroups();
  }, [loadContacts, loadGroups]);

  const resetForm = () => {
    setFormData({
      name: "",
      number: "",
      group: "",
      otherMessage: "",
      address: "",
    });
    setSelectedContact(null);
  };

  const handleCreateContact = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const payload = {
        name: formData.name,
        str_name: formData.name,
        number: formData.number,
        str_phone_number: formData.number,
        group: formData.group,
        str_group_id: formData.group,
        arr_groups: formData.group ? [formData.group] : [],
        address: formData.address,
        str_address: formData.address,
        otherMessage: formData.otherMessage,
        str_message: formData.otherMessage,
      };

      const res = await contactService.create(payload);
      if (res && (res.success || res._id)) {
        await loadContacts();
        await loadGroups();
        setShowCreateModal(false);
        resetForm();
      } else {
        alert(res?.error || res?.message || "Failed to create contact");
      }
    } catch (err) {
      alert(err.message || "Failed to create contact");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEditContact = (contact) => {
    setSelectedContact(contact);
    const grpId =
      contact.group?._id ||
      contact.str_group_id ||
      (Array.isArray(contact.arr_groups) && contact.arr_groups[0]) ||
      contact.group ||
      "";

    setFormData({
      name: contact.name || contact.str_name || "",
      number: contact.number || contact.str_phone_number || "",
      group: grpId,
      otherMessage: contact.otherMessage || contact.str_message || "",
      address: contact.address || contact.str_address || "",
    });
    setShowEditModal(true);
  };

  const handleUpdateContact = async (e) => {
    e.preventDefault();
    if (!selectedContact) return;
    setIsSubmitting(true);
    try {
      const payload = {
        name: formData.name,
        str_name: formData.name,
        number: formData.number,
        str_phone_number: formData.number,
        group: formData.group,
        str_group_id: formData.group,
        arr_groups: formData.group ? [formData.group] : [],
        address: formData.address,
        str_address: formData.address,
        otherMessage: formData.otherMessage,
        str_message: formData.otherMessage,
      };

      const id = selectedContact._id || selectedContact.id;
      const res = await contactService.edit(id, payload);
      if (res && (res.success || res._id)) {
        await loadContacts();
        await loadGroups();
        setShowEditModal(false);
        resetForm();
      } else {
        alert(res?.error || res?.message || "Failed to update contact");
      }
    } catch (err) {
      alert(err.message || "Failed to update contact");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeleteContact = async (contactId) => {
    if (!window.confirm("Are you sure you want to delete this contact?")) return;
    try {
      const res = await contactService.delete(contactId);
      if (res && res.success !== false) {
        setContacts((prev) => prev.filter((c) => (c._id || c.id) !== contactId));
        loadGroups();
      } else {
        alert(res?.error || "Failed to delete contact");
      }
    } catch (err) {
      alert(err.message || "Failed to delete contact");
    }
  };

  const handleBulkUpload = async (e) => {
    e.preventDefault();
    if (!uploadFile || !selectedGroupForUpload) {
      alert("Please select a file and group");
      return;
    }

    setIsSubmitting(true);
    setUploadingProgress("Reading file data...");

    try {
      const fileExt = uploadFile.name.split(".").pop().toLowerCase();
      let parsedContacts = [];

      if (fileExt === "xlsx" || fileExt === "xls") {
        const arrayBuffer = await uploadFile.arrayBuffer();
        const workbook = XLSX.read(arrayBuffer, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(worksheet);

        parsedContacts = rows.map((r) => {
          const keys = Object.keys(r);
          const phoneKey = keys.find((k) => /phone|number|mobile|whatsapp/i.test(k)) || "number";
          const nameKey = keys.find((k) => /name|full_name|customer/i.test(k)) || "name";
          const msgKey = keys.find((k) => /message|msg|note|other/i.test(k)) || "otherMessage";
          const addrKey = keys.find((k) => /address|city|loc/i.test(k)) || "address";

          return {
            name: r[nameKey] ? String(r[nameKey]).trim() : "",
            number: r[phoneKey] ? String(r[phoneKey]).trim() : "",
            otherMessage: r[msgKey] ? String(r[msgKey]).trim() : "",
            address: r[addrKey] ? String(r[addrKey]).trim() : "",
            group: selectedGroupForUpload,
          };
        }).filter((c) => c.number);
      } else if (fileExt === "csv") {
        const text = await uploadFile.text();
        const lines = text.split(/\r?\n/).filter((l) => l.trim().length > 0);
        if (lines.length > 1) {
          const headers = lines[0].split(",").map((h) => h.trim().replace(/^["']|["']$/g, ""));
          const phoneIdx = headers.findIndex((h) => /phone|number|mobile|whatsapp/i.test(h));
          const nameIdx = headers.findIndex((h) => /name|full_name|customer/i.test(h));
          const msgIdx = headers.findIndex((h) => /message|msg|note|other/i.test(h));
          const addrIdx = headers.findIndex((h) => /address|city|loc/i.test(h));

          for (let i = 1; i < lines.length; i++) {
            const row = lines[i].split(",").map((cell) => cell.trim().replace(/^["']|["']$/g, ""));
            const phone = phoneIdx !== -1 ? row[phoneIdx] : row[1] || row[0];
            if (phone) {
              parsedContacts.push({
                name: nameIdx !== -1 ? row[nameIdx] : row[0] || "",
                number: phone,
                otherMessage: msgIdx !== -1 ? row[msgIdx] : "",
                address: addrIdx !== -1 ? row[addrIdx] : "",
                group: selectedGroupForUpload,
              });
            }
          }
        }
      } else {
        alert("Unsupported file format. Please upload an .xlsx, .xls, or .csv file.");
        setIsSubmitting(false);
        return;
      }

      if (parsedContacts.length === 0) {
        alert("No valid contacts with phone numbers found in the uploaded file.");
        setIsSubmitting(false);
        return;
      }

      setUploadingProgress(`Uploading ${parsedContacts.length} contacts...`);
      const res = await contactService.bulkImport(parsedContacts, selectedGroupForUpload);

      if (res && res.success) {
        alert(`Successfully imported ${res.data?.insertedCount || parsedContacts.length} contacts!`);
        await loadContacts();
        await loadGroups();
        setShowBulkUploadModal(false);
        setUploadFile(null);
        setSelectedGroupForUpload("");
      } else {
        alert(res?.error || "Failed to upload contacts");
      }
    } catch (err) {
      alert("Error parsing and uploading file: " + err.message);
    } finally {
      setIsSubmitting(false);
      setUploadingProgress("");
    }
  };

  // Helper to resolve group display for a contact
  const getContactGroupInfo = (contact) => {
    if (contact.group && typeof contact.group === "object") {
      return contact.group.groupName || contact.group.str_group_name || "Group";
    }
    const grpId = contact.str_group_id || contact.group || (contact.arr_groups && contact.arr_groups[0]);
    if (!grpId) return null;
    const found = groups.find((g) => (g._id || g.id) === grpId || g.groupName === grpId || g.str_group_name === grpId);
    return found ? found.groupName || found.str_group_name : contact.str_group_name || grpId;
  };

  // Filtering
  const getFilteredContacts = () => {
    let filtered = contacts;

    if (searchTerm) {
      const q = searchTerm.toLowerCase();
      filtered = filtered.filter((contact) => {
        const name = (contact.name || contact.str_name || "").toLowerCase();
        const number = (contact.number || contact.str_phone_number || "").toLowerCase();
        const grp = (getContactGroupInfo(contact) || "").toLowerCase();
        return name.includes(q) || number.includes(q) || grp.includes(q);
      });
    }

    if (filterGroup !== "all") {
      filtered = filtered.filter((contact) => {
        const cGrpId =
          contact.group?._id ||
          contact.str_group_id ||
          (Array.isArray(contact.arr_groups) && contact.arr_groups[0]) ||
          contact.group;
        return cGrpId === filterGroup;
      });
    }

    return filtered;
  };

  // Stats calculation
  const getContactStats = () => {
    const total = contacts.length;
    const withGroups = contacts.filter((c) => getContactGroupInfo(c) !== null).length;
    const withoutGroups = total - withGroups;
    return { total, withGroups, withoutGroups };
  };

  const filteredContacts = getFilteredContacts();
  const totalPages = Math.ceil(filteredContacts.length / contactsPerPage) || 1;
  const startIndex = (currentPage - 1) * contactsPerPage;
  const paginatedContacts = filteredContacts.slice(startIndex, startIndex + contactsPerPage);
  const stats = getContactStats();

  if (loading && contacts.length === 0) {
    return (
      <div className="py-20 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading contacts...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header section with Actions */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div>
            <h1 className="text-3xl lg:text-4xl font-bold bg-gradient-to-r from-green-700 to-blue-600 bg-clip-text text-transparent mb-2">
              Contacts
            </h1>
            <p className="text-gray-600 dark:text-gray-400 text-sm sm:text-base">
              Manage your contact list and customer information
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <button
              onClick={() => setShowBulkUploadModal(true)}
              className="inline-flex items-center px-4 py-2.5 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all duration-200 shadow-sm shadow-blue-500/20 text-xs sm:text-sm cursor-pointer"
            >
              <DocumentArrowUpIcon className="w-5 h-5 mr-2" />
              Bulk Upload
            </button>
            <button
              onClick={() => {
                resetForm();
                setShowCreateModal(true);
              }}
              className="inline-flex items-center px-4 py-2.5 bg-gradient-to-r from-green-600 to-blue-600 text-white font-semibold rounded-xl hover:from-green-700 hover:to-blue-700 transition-all duration-200 shadow-sm shadow-green-500/20 text-xs sm:text-sm cursor-pointer"
            >
              <PlusIcon className="w-5 h-5 mr-2" />
              Add Contact
            </button>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700">
          <div className="text-2xl font-bold text-gray-900 dark:text-white">{stats.total}</div>
          <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-0.5">Total Contacts</div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700">
          <div className="text-2xl font-bold text-green-600">{stats.withGroups}</div>
          <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-0.5">With Groups</div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700">
          <div className="text-2xl font-bold text-orange-600">{stats.withoutGroups}</div>
          <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-0.5">Without Groups</div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700">
          <div className="text-2xl font-bold text-blue-600">{groups.length}</div>
          <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-0.5">Total Groups</div>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row flex-wrap gap-4 items-stretch sm:items-center">
          {/* Search */}
          <div className="relative flex-1 min-w-[240px]">
            <MagnifyingGlassIcon className="w-5 h-5 absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search contacts..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
              className="pl-12 pr-4 py-2 w-full border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
            />
          </div>

          {/* Group Filter */}
          <div className="relative">
            <FunnelIcon className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
            <select
              value={filterGroup}
              onChange={(e) => {
                setFilterGroup(e.target.value);
                setCurrentPage(1);
              }}
              className="pl-9 pr-8 py-2 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
            >
              <option value="all">All Groups</option>
              {groups.map((group) => (
                <option key={group._id || group.id} value={group._id || group.id}>
                  {group.groupName || group.str_group_name}
                </option>
              ))}
            </select>
          </div>

          {/* Per-page Selector */}
          <div className="relative">
            <select
              value={contactsPerPage}
              onChange={(e) => {
                setContactsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
            >
              <option value={10}>10 per page</option>
              <option value={20}>20 per page</option>
              <option value={50}>50 per page</option>
              <option value={100}>100 per page</option>
            </select>
          </div>
        </div>
      </div>

      {/* Contacts Table */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
        {paginatedContacts.length === 0 ? (
          <div className="py-12 px-4 text-center">
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">No Contacts Found</h3>
            <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md mx-auto text-sm">
              {contacts.length === 0
                ? "You don't have any contacts yet. Add your first contact to get started."
                : "No contacts match your current filters. Try adjusting your search or filter criteria."}
            </p>
            {contacts.length === 0 && (
              <button
                onClick={() => {
                  resetForm();
                  setShowCreateModal(true);
                }}
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-green-600 to-blue-600 text-white font-semibold rounded-xl hover:from-green-700 hover:to-blue-700 transition-all duration-200 text-sm cursor-pointer"
              >
                <PlusIcon className="w-5 h-5 mr-2" />
                Add Contact
              </button>
            )}
          </div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead className="bg-gray-50 dark:bg-gray-700/60">
                  <tr>
                    <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider w-16">
                      #
                    </th>
                    <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      Contact Info
                    </th>
                    <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      Group
                    </th>
                    <th className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      Message
                    </th>
                    <th className="px-6 py-3.5 text-right text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                  {paginatedContacts.map((contact, index) => {
                    const groupName = getContactGroupInfo(contact);
                    const name = contact.name || contact.str_name || "No Name";
                    const number = contact.number || contact.str_phone_number || "-";
                    const address = contact.address || contact.str_address;
                    const message = contact.otherMessage || contact.str_message;
                    const id = contact._id || contact.id;

                    return (
                      <tr
                        key={id || index}
                        className="hover:bg-gray-50/80 dark:hover:bg-gray-700/50 transition-colors duration-150"
                      >
                        <td className="px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-400">
                          #{(currentPage - 1) * contactsPerPage + index + 1}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex flex-col">
                            <div className="text-sm font-semibold text-gray-900 dark:text-white">
                              {name}
                            </div>
                            <div className="text-xs font-mono font-medium text-gray-500 dark:text-gray-400 mt-0.5">
                              {number}
                            </div>
                            {address && (
                              <div className="text-[11px] text-gray-400 dark:text-gray-500 mt-0.5">
                                📍 {address}
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {groupName ? (
                            <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200">
                              {groupName}
                            </span>
                          ) : (
                            <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300">
                              No Group
                            </span>
                          )}
                        </td>
                        <td className="px-6 py-4">
                          <div className="text-xs text-gray-600 dark:text-gray-400 max-w-xs">
                            <p className="line-clamp-2 break-words">{message || "No message"}</p>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                          <div className="flex items-center justify-end space-x-2">
                            <button
                              onClick={() => handleEditContact(contact)}
                              className="p-2 text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-lg transition-colors duration-200 cursor-pointer"
                              title="Edit Contact"
                            >
                              <PencilIcon className="w-4 h-4" />
                            </button>
                            <button
                              onClick={() => handleDeleteContact(id)}
                              className="p-2 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors duration-200 cursor-pointer"
                              title="Delete Contact"
                            >
                              <TrashIcon className="w-4 h-4" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
                  Showing {(currentPage - 1) * contactsPerPage + 1} to{" "}
                  {Math.min(currentPage * contactsPerPage, filteredContacts.length)} of{" "}
                  {filteredContacts.length} contacts
                </div>

                <div className="flex items-center space-x-1">
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                    disabled={currentPage === 1}
                    className="p-2 rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                  >
                    <ChevronLeftIcon className="w-4 h-4" />
                  </button>

                  {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                    const pageNum = i + Math.max(1, currentPage - 2);
                    if (pageNum > totalPages) return null;
                    return (
                      <button
                        key={pageNum}
                        onClick={() => setCurrentPage(pageNum)}
                        className={`px-3 py-1.5 text-xs sm:text-sm font-medium rounded-lg transition-colors ${
                          currentPage === pageNum
                            ? "bg-green-600 text-white"
                            : "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white"
                        }`}
                      >
                        {pageNum}
                      </button>
                    );
                  })}

                  <button
                    onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                    disabled={currentPage === totalPages}
                    className="p-2 rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                  >
                    <ChevronRightIcon className="w-4 h-4" />
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Create Contact Modal */}
      {showCreateModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl border border-gray-200 dark:border-gray-700">
            <div className="sticky top-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between z-10">
              <h3 className="text-lg font-bold text-gray-900 dark:text-white">Add New Contact</h3>
              <button
                onClick={() => {
                  setShowCreateModal(false);
                  resetForm();
                }}
                className="p-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-lg transition-colors cursor-pointer"
              >
                <XMarkIcon className="w-5 h-5" />
              </button>
            </div>
            <form onSubmit={handleCreateContact} className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                    required
                    placeholder="e.g. John Doe"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    value={formData.number}
                    onChange={(e) => setFormData({ ...formData, number: e.target.value })}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm font-mono focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                    required
                    placeholder="e.g. +919876543210"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Group
                  </label>
                  <select
                    value={formData.group}
                    onChange={(e) => setFormData({ ...formData, group: e.target.value })}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                  >
                    <option value="">Select a group</option>
                    {groups.map((group) => (
                      <option key={group._id || group.id} value={group._id || group.id}>
                        {group.groupName || group.str_group_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Address
                  </label>
                  <input
                    type="text"
                    value={formData.address}
                    onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                    placeholder="Enter city / address"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Message / Notes
                  </label>
                  <textarea
                    value={formData.otherMessage}
                    onChange={(e) => setFormData({ ...formData, otherMessage: e.target.value })}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                    rows="3"
                    placeholder="Enter additional message or notes"
                  />
                </div>
              </div>
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100 dark:border-gray-700">
                <button
                  type="button"
                  onClick={() => {
                    setShowCreateModal(false);
                    resetForm();
                  }}
                  className="px-5 py-2 text-xs font-semibold text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl transition-all cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-green-700 hover:bg-green-800 disabled:bg-gray-400 text-white px-6 py-2 rounded-xl transition-all flex items-center gap-2 text-xs font-semibold shadow-sm shadow-green-600/20 cursor-pointer"
                >
                  {isSubmitting ? (
                    <>
                      <div className="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
                      Creating...
                    </>
                  ) : (
                    <>
                      <CheckIcon className="w-4 h-4" />
                      Create Contact
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Contact Modal */}
      {showEditModal && selectedContact && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl border border-gray-200 dark:border-gray-700">
            <div className="sticky top-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between z-10">
              <h3 className="text-lg font-bold text-gray-900 dark:text-white">Edit Contact</h3>
              <button
                onClick={() => {
                  setShowEditModal(false);
                  resetForm();
                }}
                className="p-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-lg transition-colors cursor-pointer"
              >
                <XMarkIcon className="w-5 h-5" />
              </button>
            </div>
            <form onSubmit={handleUpdateContact} className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                    required
                    placeholder="Enter contact name"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    value={formData.number}
                    onChange={(e) => setFormData({ ...formData, number: e.target.value })}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm font-mono focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                    required
                    placeholder="Enter phone number"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Group
                  </label>
                  <select
                    value={formData.group}
                    onChange={(e) => setFormData({ ...formData, group: e.target.value })}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                  >
                    <option value="">Select a group</option>
                    {groups.map((group) => (
                      <option key={group._id || group.id} value={group._id || group.id}>
                        {group.groupName || group.str_group_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Address
                  </label>
                  <input
                    type="text"
                    value={formData.address}
                    onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                    placeholder="Enter address"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Message / Notes
                  </label>
                  <textarea
                    value={formData.otherMessage}
                    onChange={(e) => setFormData({ ...formData, otherMessage: e.target.value })}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                    rows="3"
                    placeholder="Enter additional message or notes"
                  />
                </div>
              </div>
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100 dark:border-gray-700">
                <button
                  type="button"
                  onClick={() => {
                    setShowEditModal(false);
                    resetForm();
                  }}
                  className="px-5 py-2 text-xs font-semibold text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl transition-all cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-green-700 hover:bg-green-800 disabled:bg-gray-400 text-white px-6 py-2 rounded-xl transition-all flex items-center gap-2 text-xs font-semibold shadow-sm shadow-green-600/20 cursor-pointer"
                >
                  {isSubmitting ? (
                    <>
                      <div className="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
                      Updating...
                    </>
                  ) : (
                    <>
                      <CheckIcon className="w-4 h-4" />
                      Update Contact
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Bulk Upload Modal */}
      {showBulkUploadModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl max-w-md w-full shadow-2xl border border-gray-200 dark:border-gray-700">
            <div className="border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between">
              <h3 className="text-lg font-bold text-gray-900 dark:text-white">Bulk Upload Contacts</h3>
              <button
                onClick={() => {
                  setShowBulkUploadModal(false);
                  setUploadFile(null);
                  setSelectedGroupForUpload("");
                }}
                className="p-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-lg transition-colors cursor-pointer"
              >
                <XMarkIcon className="w-5 h-5" />
              </button>
            </div>
            <form onSubmit={handleBulkUpload} className="p-6">
              <div className="space-y-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Select Target Group *
                  </label>
                  <select
                    value={selectedGroupForUpload}
                    onChange={(e) => setSelectedGroupForUpload(e.target.value)}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                    required
                  >
                    <option value="">Choose a group</option>
                    {groups.map((group) => (
                      <option key={group._id || group.id} value={group._id || group.id}>
                        {group.groupName || group.str_group_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5">
                    Excel / CSV Spreadsheet *
                  </label>
                  <input
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                    className="w-full px-3.5 py-2.5 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs sm:text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:text-xs file:font-semibold file:bg-blue-50 dark:file:bg-blue-900/30 file:text-blue-700 dark:file:text-blue-300 cursor-pointer"
                    required
                  />
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-1.5 leading-relaxed">
                    Supported format: <strong>.xlsx, .xls, .csv</strong> with columns: <em>name, number, message, address</em>.
                  </p>
                </div>
                {uploadingProgress && (
                  <div className="p-3 rounded-xl bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 text-xs font-medium animate-pulse">
                    {uploadingProgress}
                  </div>
                )}
              </div>
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100 dark:border-gray-700">
                <button
                  type="button"
                  onClick={() => {
                    setShowBulkUploadModal(false);
                    setUploadFile(null);
                    setSelectedGroupForUpload("");
                  }}
                  className="px-5 py-2 text-xs font-semibold text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl transition-all cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting || !uploadFile || !selectedGroupForUpload}
                  className="bg-blue-700 hover:bg-blue-800 disabled:bg-gray-400 text-white px-6 py-2 rounded-xl transition-all flex items-center gap-2 text-xs font-semibold shadow-sm shadow-blue-600/20 cursor-pointer"
                >
                  {isSubmitting ? (
                    <>
                      <div className="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-white"></div>
                      Uploading...
                    </>
                  ) : (
                    <>
                      <DocumentArrowUpIcon className="w-4 h-4" />
                      Upload Contacts
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
